/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PaymentNotice } from "./PaymentNotice";
import * as t from "io-ts";
import { EmailString } from "@pagopa/ts-commons/lib/strings";

/**
 * Cart request body
 */

/**
 * Structure containing all the returning URL's to which user will be redirect after payment process has been completed
 */

// required attributes
const CartRequestReturnUrlsR = t.interface({
  returnOkUrl: t.string,

  returnCancelUrl: t.string,

  returnErrorUrl: t.string
});

// optional attributes
const CartRequestReturnUrlsO = t.partial({
  returnWaitingUrl: t.string
});

export const CartRequestReturnUrls = t.intersection(
  [CartRequestReturnUrlsR, CartRequestReturnUrlsO],
  "CartRequestReturnUrls"
);

export type CartRequestReturnUrls = t.TypeOf<typeof CartRequestReturnUrls>;

// required attributes
const CartRequestR = t.interface({
  paymentNotices: t.readonlyArray(PaymentNotice, "array of PaymentNotice"),

  returnUrls: CartRequestReturnUrls
});

// optional attributes
const CartRequestO = t.partial({
  emailNotice: EmailString,

  idCart: t.string,

  allCCP: t.boolean
});

export const CartRequest = t.intersection(
  [CartRequestR, CartRequestO],
  "CartRequest"
);

export type CartRequest = t.TypeOf<typeof CartRequest>;
